export default __webpack_public_path__ + "static/media/Frame2.5464c932.png";